import { FontsMap } from '@packages/style/fonts';

export const FONTS: FontsMap = {
    secondary: {
        font: 'Fira Sans',
        weight: 400,
        size: 14,
        variations: [400, 500, 600, 700],
        fallback: "'Roboto', Montserrat, Helvetica, Arial, sans-serif",
    },
    primary: {
        font: 'Roboto',
        weight: 400,
        size: 14,
        variations: [400, 500, 700],
        fallback: "'Fira Sans', Helvetica, Arial, sans-serif",
    },
    monospace: {
        font: 'Ubuntu Mono',
        weight: 400,
        size: 14,
        variations: [400],
        fallback: '"SF Mono", "Roboto Mono", Menlo, monospace',
    },
    icons: {
        font: 'Material Icons',
        size: 24,
    },
};
